import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Role } from "../types/Auth";

/**
 * Component that redirects users based on their role.
 * - Partner users → /partner/orders
 * - Owner users → /admin/partnerships
 * - Other authenticated users → /account/dashboard
 */
const RoleBasedRedirect: React.FC = () => {
  const { user } = useAuth();

  // Redirect based on user role
  if (user?.role === Role.partner) {
    return <Navigate to="/partner/orders" replace />;
  }

  if (user?.role === Role.owner) {
    return <Navigate to="/admin/partnerships" replace />;
  }

  // Default redirect for other authenticated users
  return <Navigate to="/account/dashboard" replace />;
};

export default RoleBasedRedirect;
